document.addEventListener("DOMContentLoaded", async () => {
  const productId = document.querySelector("[data-product-id]")?.dataset.productId;
  if (!productId) return;

  const target = document.querySelector("#similar-products-wrapper");
  if (!target) return;

  try {
    const response = await fetch(`https://shop-similar-api-f368b3fe3716.herokuapp.com/similar?product_id=${productId}`);
    const data = await response.json();

    if (!Array.isArray(data) || data.length === 0 || !data[0].handle) {
      const wrapper = document.getElementById("similar-products-wrapper");
      if (wrapper) wrapper.remove();
      return;
    }

    const ul = target.querySelector("ul.slider__grid");
    if (!ul) return;

    // Ürünleri DOM’a ekle
    data.forEach(product => {
      const href = `/products/${product.handle}`;
      const li = document.createElement("li");
      li.className = "slider__item";
      li.innerHTML = `
        <product-card class="card card--product h-full card--no-lines relative flex">
          <div class="card__media relative" style="max-height: 250px;">
            <a href="${href}" class="media block relative js-prod-link" style="padding-top: 111.11%;">
              <img src="${product.image}" class="img-fit img-fit--contain card__main-image" style="max-height: 250px;" alt="${product.title}">
            </a>
          </div>
          <div class="card__info-container flex flex-col flex-auto relative">
            <div class="card__info w-full">
              <p class="card__vendor mb-0 text-sm text-theme-light">${product.vendor}</p>
              <p class="card__title font-bold mt-1 mb-0">
                <a href="${href}" class="card-link text-current js-prod-link">${product.title}</a>
              </p>
              <div class="price price--on-sale price--top">
                <div class="price__default">
                  <strong class="price__current">$${product.price}</strong>
                  ${product.compare_at_price ? `<s class="price__was">$${product.compare_at_price}</s>` : ""}
                </div>
              </div>
            </div>
          </div>
        </product-card>
      `;
      ul.appendChild(li);
    });

    // SLIDER'I SONRA BAŞLAT

  } catch (err) {
    console.error("Benzer ürünler yüklenemedi:", err);
  }
});
